import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';
import type { PersonalWorkLogEntry } from '../../query/jiraTracker/jiraTrackerQuery.services';

export type UpsertPersonalWorkLogPayload = {
    PersonalWorkLogEntryId?: number | null;
    WorkDate: string;
    Title: string;
    TicketId?: string | null;
    DurationMinutes: number;
    TechnicalNotes?: string | null;
    Notes?: string | null;
    IsCompleted: boolean;
    SortOrder?: number;
    PriorityColor?: string | null;
};

const UpsertPersonalWorkLogEntry = (
    data: UpsertPersonalWorkLogPayload
): Promise<{ entry: PersonalWorkLogEntry }> =>
    request({
        url: ApiURL.Command.PERSONAL_WORK_LOG_UPSERT,
        method: RequestType.POST,
        data,
    });

const DeletePersonalWorkLogEntry = (data: {
    PersonalWorkLogEntryId: number;
}): Promise<{ deleted: boolean }> =>
    request({
        url: ApiURL.Command.PERSONAL_WORK_LOG_DELETE,
        method: RequestType.POST,
        data,
    });

const JiraTrackerCommand = {
    UpsertPersonalWorkLogEntry,
    DeletePersonalWorkLogEntry,
};

export default JiraTrackerCommand;
